/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_StartInputs */



/**
* | output |
* | --- |
* | "Start" |
*
* @param {Tfield_StartInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_start = /** @type {((inputs?: Tfield_StartInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_StartInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Début")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inicio")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Início")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inizio")
	return /** @type {LocalizedString} */ ("Start")
});